import { render, staticRenderFns } from "./TableUni.vue?vue&type=template&id=7f185932&scoped=true"
import script from "./TableUni.vue?vue&type=script&lang=js"
export * from "./TableUni.vue?vue&type=script&lang=js"
import style0 from "./TableUni.vue?vue&type=style&index=0&id=7f185932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f185932",
  null
  
)

export default component.exports